import { ActionTree } from 'vuex';
import { CampaignState } from './CampaignTypes';
import { RootState } from '@/app/shared/store/RootState';

export const actions: ActionTree<CampaignState, RootState> = {
  triggerCampaignReload({ commit }) {
    commit('setReloadingCampaigns', true);
  },
  setCampaignReloadingState({ commit }, payload: boolean) {
    commit('setReloadingCampaigns', payload);
  },
};
